import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/contexts/StoreContext';
import { MousePointer, Square, Circle, Diamond, ArrowRight, Minus, Type, Layers, Clipboard } from 'lucide-react';
import type { ToolType } from '@/types';
import styles from './ToolBox.module.css';

const TOOLS: { type: ToolType; icon: React.ReactNode; shortcut: string }[] = [
  { type: 'select', icon: <MousePointer size={20} />, shortcut: '1' },
  { type: 'rectangle', icon: <Square size={20} />, shortcut: '2' },
  { type: 'ellipse', icon: <Circle size={20} />, shortcut: '3' },
  { type: 'diamond', icon: <Diamond size={20} />, shortcut: '4' },
  { type: 'arrow', icon: <ArrowRight size={20} />, shortcut: '5' },
  { type: 'line', icon: <Minus size={20} />, shortcut: '6' },
  { type: 'text', icon: <Type size={20} />, shortcut: '7' },
  { type: 'icon', icon: <Layers size={20} />, shortcut: '8' },
  { type: 'image', icon: <Clipboard size={20} />, shortcut: '9' },
];

export const ToolBox: React.FC = observer(() => {
  const { uiStore } = useStores();
  const activeTool = uiStore.activeTool;

  const handleToolSelect = (toolType: ToolType) => {
    uiStore.setActiveTool(toolType);
  };

  return (
    <div className={styles['toolbox']}>
      <div className={styles['toolGroup']}>
        {TOOLS.map(({ type, icon, shortcut }) => (
          <button
            key={type}
            className={`${styles['toolButton']} ${
              activeTool === type ? styles['active'] : ''
            }`}
            onClick={() => handleToolSelect(type)}
            title={`${type.charAt(0).toUpperCase() + type.slice(1)} (${shortcut})`}
            aria-label={type}
          >
            <span className={styles['toolIcon']}>{icon}</span>
            <span className={styles['shortcut']}>{shortcut}</span>
          </button>
        ))}
      </div>
    </div>
  );
}); 